<!-- Toast Container - Theme-Aware Version -->
<div [ngClass]="currentTheme === 'dark' ? 'toast-container-dark' : 'toast-container-light'"
     style="position: fixed !important; top: 20px !important; right: 20px !important; z-index: 999999 !important; max-width: 400px !important; display: flex !important; flex-direction: column !important; gap: 12px !important;">

  <!-- Toast Items -->
  <div *ngFor="let toast of toasts$ | async; trackBy: trackByToast"
       [ngClass]="['toast-item', 'toast-' + toast.type, currentTheme === 'dark' ? 'toast-dark' : 'toast-light']"
       [style.border-left-color]="getIconColor(toast.type)"
       style="border-radius: 8px !important; padding: 16px !important; border-left: 4px solid !important; min-width: 320px !important; opacity: 1 !important; transform: translateX(0) !important;">

    <div style="display: flex !important; align-items: center !important; gap: 12px !important;">
      <!-- Toast Icon -->
      <div style="font-size: 20px !important; flex-shrink: 0 !important;">
        <app-icon [name]="getIcon(toast.type)" [size]="20" [style.color]="getIconColor(toast.type)"></app-icon>
      </div>

      <!-- Toast Message -->
      <div style="flex: 1 !important; font-size: 14px !important; font-weight: 500 !important; line-height: 1.4 !important;">
        {{ toast.message }}
      </div>

      <!-- Close Button -->
      <button (click)="removeToast(toast.id)"
              [ngClass]="currentTheme === 'dark' ? 'toast-close-dark' : 'toast-close-light'"
              style="background: none !important; border: none !important; padding: 4px !important; border-radius: 4px !important; cursor: pointer !important; font-size: 18px !important; line-height: 1 !important; transition: all 0.2s !important; flex-shrink: 0 !important;">
        ×
      </button>
    </div>
  </div>
</div>